<script>
import School from './schoolSelect.vue';
export default {
  name: 'Area',
  extends: School,
  props: {
    showSchool: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '国家及地区'
    }
  }
};
</script>
